var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('assign-personal-panel',{ref:"panel",attrs:{"config":_vm.tabConfig,"users-loading":_vm.usersLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }